import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CourseDetail from '../../coursDetail/courseDetail';
import { API_URL } from '../../../config';
import axios from 'axios';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';
// import GetContract from './getContract/getContract';
// import AcceptInput from '../../chooseUserBuy/accept/accept';
// import CustomLink from '../../../components/Elements/Link/link';
 import CustomButtons from '../../../components/Elements/Buttons/customButton';
import "./summaryOrder.css"




 
const SummaryOrder = (props) => {
    const [isPAymentReady, sePaymentReady] = useState(0)
    const history = useHistory();
    const proxySendURL = `${API_URL}ProxySend`
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    let key = localStorage.getItem('keyURL')
    let urlPush = localStorage.getItem('pushURL')
    let userID = localStorage.getItem('usersID')
    let parcipientName =  localStorage.getItem('userName');
    const guID =localStorage.getItem("guid");   
    if(parcipientName == null){
        parcipientName =  localStorage.getItem('payerName');    
    }
    const installment = JSON.parse(localStorage.getItem('installment'))
    let amount1 = 0;
    let amount2 = 0;
    let globalResponse;
    function registerClick(){
        let urlParams ="https://panelklienta.egurrola.com/ThankYou"
        const formData = {
            type: 'OrderPayment',
            body: {
                guid: guID,          
                 paymentMethodsP24:5,               
                 returnUrl: urlParams,
                 current_LocalizationsID: -1,
            },
        };
       
        axios
            .post(proxySendURL, formData, config)
            .then((response) => {
                globalResponse = response.data.requestId;
                if(response.data.recheck){
                    methodProxyGetMessage();
                } else {
          
                 }
            })
            .catch(function (error) {
            console.log(error)
                if (error.response.status == 401) {
                    // history.push('/Error_ogolny');
                }
            });
    }
    if(!props.isBillet){
    for(var i = 0; i <props.installment.paymentShedule.length;i++){

        if(props.data.listOfInstallment.includes(props.installment.paymentShedule[i].countNumber)){
                
            amount1 += parseFloat(props.installment.paymentShedule[i].paymentPositionPrice);
            amount2 += parseFloat(props.installment.paymentShedule[i].paymentPositionPriceDiscount)
          }
    }}
    const methodProxySend = () => {
        console.log('props.trackingId')
        console.log(props.trackingId)
         let urlParams ="https://panelklienta.egurrola.com/ThankYou"
        const formData = {
            type: 'OrderPayment',
            body: {
                guid:props.trackingId,          
                 paymentMethodsP24:'5',               
                 returnUrl: urlParams,
                 current_LocalizationsID: -1,
            },
        };
       
        axios
            .post(proxySendURL, formData, config)
            .then((response) => {
                globalResponse = response.data.requestId;
                if(response.data.recheck){
                    methodProxyGetMessage();
                } else {
                //     document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
                //     if(response.data.message === 'Other created'){
                        
             
                        
                //     }
                //     if(response.data.message === "Fault"){
                
                       
                //     } 
                //     if(response.data.message == 'Other requested'){
                //         // umowa jest w trakcie procesowania uder create
                //         // dispatch(setMessege('Umowa jest w trakcie tworzenia.'));
                  
                //         methodProxyGetMessage();
                //     }
                 }
            })
            .catch(function (error) {
            console.log(error)
                if (error.response.status == 401) {
                    // history.push('/Error_ogolny');
                }
            });
    };
    const methodProxyGetMessage = () => {
        const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
        axios
            .get(proxyGetMessageURL, config)
            .then((proxyGetMessageUrlResponse) => {
                if (proxyGetMessageUrlResponse.data.responseBody != null) {
                if(proxyGetMessageUrlResponse.data.responseBody.status == 200){
             
                    localStorage.setItem('pushURL', proxyGetMessageUrlResponse.data.responseBody.body.html)
                    sePaymentReady(20)
       
                }             
                    else if(proxyGetMessageUrlResponse.data.responseBody.status == 401){
                        history.push('/Error_ogolny');
                     
                    }else  
                        if(proxyGetMessageUrlResponse.data.responseBody.includes("Trying to get property 'paymentCardID' of non-object in") ){
                            sePaymentReady(42)
                            //Wiadomość nie można było przygotować płatności ponieważ brak karty
                            //Co robić w tej sytuacji 
                    }else{
                            sePaymentReady(40)
                        }
                    
                    
                } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                    setTimeout(() => methodProxyGetMessage(), 10000);
                } else if (proxyGetMessageUrlResponse.data.recheck == false) {
                    sePaymentReady(40)
                }
            })
            .catch(function (error) {
                if (error.response != null) {
                    if (error.response.status == 401) {
                        // history.push('/Error_ogolny');
                    }
                } else {
                    // window.location.replace(
                    //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                    // );
                }
            });
    };

    useEffect(()=>{
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
     'event' : 'confirmation'
        });
     
        methodProxySend();
    },[])
    return <> 
    
    <div className='summaryOrder_wrapper'>
    <div className='summaryOrder_positionWrapper'> 
    <div className='summaryOrder_position'>    
    <CustomTittle>Podsumowanie zamówienia</CustomTittle>
    <div className='summaryOrder_content'>
        <div className=' summaryOrder_courseDetail'>
        <CourseDetail forceDisplay={true}  wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
                       
        </div>
        <div className=' summaryOrder_userDetail'>
                <div className="summaryOrder_userDetail_wrapper">
        <UserDetailPopUp force={true} onclick={()=>{}} title="Uczestnik:" label={parcipientName} ></UserDetailPopUp>
        <UserDetailPopUp force={true} onclick={()=>{}} title="Data rozpoczęcia:" label={props.start.split("-")[2] +"-"+ props.start.split("-")[1] +"-"+ props.start.split("-")[0]} ></UserDetailPopUp>
        {props.isBillet?<UserDetailPopUp force={true} onclick={()=>{}} title="Szczegóły karnetu" hint={`za ${props.data.variantBillet.count} lekcje`} label={`${props.data.variantBillet.amount} zł`} ></UserDetailPopUp>:<UserDetailPopUp force={true} onclick={()=>{}} title="Wariant cenowy:" hint={props.data.varaintHint} label={props.data.variantTittle} ></UserDetailPopUp>}
        {props.isBillet?"": <UserDetailPopUp force={true} title="Kod rabatowy:" onclick={()=>{}} label={props.discountD.length !=0?"-"+props.discountD.discountValue+"%": "Brak"} ></UserDetailPopUp>}
        <UserDetailPopUp force={true} title="Forma płatności:"  onclick={()=>{}} label={props.data.choosenPaymentOption == "5"?"Przelewy24":"Karta płatnicza"} ></UserDetailPopUp>
        </div>   </div> 
    
  </div></div>
        <div  className='summaryOrder_summary'>
                <div className='Installment_summary'>
                        <div className='summaryOrder_summaryDetails'> 
                            <div className='summaryOrder_summaryValue'><p className='summaryValue_slim' >Wartość:</p> <p className='summaryValue_bold'>{props.isBillet?props.data.variantBillet.amount.toFixed(2).toString().replace(".",","):amount1.toFixed(2).toString().replace(".",",")} zł</p></div>
                            {props.isBillet?"":<div className='summaryOrder_summaryValue'><p className='summaryValue_slim'>Opłata Wpisowa:</p><p className='summaryValue_bold'>{props.data.entryFee != null?parseFloat(props.data.entryFee).toFixed(2).toString().replace(".",","):"0,00"} zł</p></div>}
                            {props.isBillet?"":<div className='summaryOrder_summaryValue'><p className='summaryValue_slim'>Rabat:</p> <p className='summaryValue_bold'>-{( amount1 - amount2).toFixed(2).toString().replace(".",",")} zł</p></div>  }           
                            <p className='amountSummaryOrder'>DO ZAPŁATY:    { props.isBillet?<CustomTittle>{props.data.variantBillet.amount.toString().replace(".",",")} zł</CustomTittle>:<CustomTittle>{props.data.entryFee != null?(parseFloat(props.data.entryFee) + amount2).toFixed(2).toString().replace(".",","):amount2.toString().replace(".",",")} zł</CustomTittle>}</p>
                        </div> 
                        {isPAymentReady == 0? <div className="awaitPayment"><p className="awaitPaymentText">Trwa przygotowywanie płatności</p> <div className="dot"></div> <div className="dot"></div> <div className="dot"></div> </div>:""}
    {isPAymentReady == 20? <CustomButtons clickFunction={(e)=>window.location.replace(urlPush)} classButton="solid" size="big">PRZEJDŹ DO PŁATNOŚCI</CustomButtons>:""}
    {isPAymentReady == 40? <p>Nie mogliśmy przygotować twoje płątności. Możesz ponowić próbę dokonania płatności w panelu klienta.</p>:""}
    {isPAymentReady == 42? <p>Nie mogliśmy przygotować twoje płątności, ponieważ wybrałem płatność kartą jako twoją formę płatności a nie masz podpięte żadnej karty płatniczej. Karte płatniczą możęsz dodać w panelu klienta.</p>:""}
    
               
                </div>    
        </div></div>
  </div>
    </>;
    }

export default SummaryOrder;
